<template>
    <div>
        <div v-for="(question, index) in questions" :key="question.question.id" class="question-wrapper">
            <div v-if="surveyType === 'nis2' && hasHelperBotLicense" class="chat-icon-wrapper">
                <HelperBot 
                    :question="question.question" />
            </div>
            
            <div class="question-component">
                <component 
                    :is="getQuestionComponent(question)"
                    :id="question.question.id"
                    :question="question"
                    :index="index"
                    :updating="updating"
                    @onValueChange="onValueChange" />
            </div>
        </div>
    </div>
</template>

<script>
import { useStore } from "@/store";
import HelperBot from "@/components/HelperBot/HelperBot.vue";

export default {
    name: "Questions",
    components: {
        HelperBot
    },
    setup() {
        return {
            state: useStore().state,
            setState: useStore().setState,
        };
    },
    created() {
    },
    props: {
        questions: {
            type: Array,
            default: function () {
                return []
            },
        },
        updating: {
            type: Boolean,
            default: false
        },
        surveyType: {
            type: String,
            required: true
        }
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    updated() {},
    watch: {
    },
    computed: {
        hasHelperBotLicense() {
            return this.state.licenses?.some(license => 
                license.api?.toLowerCase().startsWith('/helperbot/')
            );
        }
    },
    methods: {
        getQuestionComponent (question) {
            return `question-${question.question.question_type}`
        },
        onValueChange (question, answer) {
            this.$emit('onValueChange', question, answer)
        },
    }
};
</script>

<style lang="scss" scoped>
.question-wrapper {
    position: relative;
    display: flex;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 1rem;
}

.chat-icon-wrapper {
    flex-shrink: 0;
    margin-right: 1rem;
    padding-top: 0.5rem;
}

.question-component {
    flex: 1;
    min-width: 0;
}

@media screen and (max-width: 768px) {
    .question-wrapper {
        margin-bottom: 0.5rem;
    }

    .chat-icon-wrapper {
        margin-right: 0.5rem;
    }
}

@media screen and (max-width: 480px) {
    .chat-icon-wrapper {
        transform: scale(0.9);
    }
}
</style>